import Footer from '../../components/feature/Footer';
import CookieConsent from '../../components/feature/CookieConsent';

export default function Datenschutz() {
  return (
    <div className="min-h-screen bg-white">
      <CookieConsent />
      
      {/* Header */}
      <header className="bg-gray-900 text-white py-6">
        <div className="container mx-auto px-6">
          <a href="/" className="text-2xl font-bold hover:text-blue-400 transition-colors cursor-pointer">
            SuperOne
          </a>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-8">Datenschutzerklärung</h1>
        
        <div className="prose prose-lg max-w-none">
          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">1. Datenschutz auf einen Blick</h2>
          
          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Allgemeine Hinweise</h3>
          <p className="text-gray-700 mb-4">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. 
            Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können. Ausführliche Informationen zum Thema Datenschutz 
            entnehmen Sie unserer unter diesem Text aufgeführten Datenschutzerklärung.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Datenerfassung auf dieser Website</h3>
          <p className="text-gray-700 mb-4">
            <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
            Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
          </p>
          <p className="text-gray-700 mb-4">
            <strong>Wie erfassen wir Ihre Daten?</strong><br />
            Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein 
            Kontaktformular eingeben. Andere Daten werden automatisch oder nach Ihrer Einwilligung beim Besuch der Website durch unsere IT-Systeme erfasst. 
            Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).
          </p>
          <p className="text-gray-700 mb-4">
            <strong>Wofür nutzen wir Ihre Daten?</strong><br />
            Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres 
            Nutzerverhaltens verwendet werden.
          </p>
          <p className="text-gray-700 mb-4">
            <strong>Welche Rechte haben Sie bezüglich Ihrer Daten?</strong><br />
            Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. 
            Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, 
            können Sie diese Einwilligung jederzeit für die Zukunft widerrufen. Außerdem haben Sie das Recht, unter bestimmten Umständen die Einschränkung der 
            Verarbeitung Ihrer personenbezogenen Daten zu verlangen.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">2. Hosting</h2>
          <p className="text-gray-700 mb-4">
            Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
          </p>
          <p className="text-gray-700 mb-4">
            <strong>Externes Hosting</strong><br />
            Diese Website wird extern gehostet. Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters / 
            der Hoster gespeichert. Hierbei kann es sich v.a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, 
            Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">3. Allgemeine Hinweise und Pflichtinformationen</h2>
          
          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Datenschutz</h3>
          <p className="text-gray-700 mb-4">
            Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und 
            entsprechend den gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
          </p>
          <p className="text-gray-700 mb-4">
            Wenn Sie diese Website benutzen, werden verschiedene personenbezogene Daten erhoben. Personenbezogene Daten sind Daten, mit denen Sie persönlich 
            identifiziert werden können. Die vorliegende Datenschutzerklärung erläutert, welche Daten wir erheben und wofür wir sie nutzen. Sie erläutert auch, 
            wie und zu welchem Zweck das geschieht.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Hinweis zur verantwortlichen Stelle</h3>
          <p className="text-gray-700 mb-4">
            Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="text-gray-700 mb-4">
            Future Now UG (haftungsbeschränkt)<br />
            Max-Planck-Str. 4<br />
            85609 Aschheim<br />
            Deutschland
          </p>
          <p className="text-gray-700 mb-4">
            E-Mail: <a href="mailto:info@future-now.online" className="text-blue-600 hover:text-blue-700 underline cursor-pointer">info@future-now.online</a>
          </p>
          <p className="text-gray-700 mb-4">
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder gemeinsam mit anderen über die Zwecke und Mittel der 
            Verarbeitung von personenbezogenen Daten (z.B. Namen, E-Mail-Adressen o. Ä.) entscheidet.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Speicherdauer</h3>
          <p className="text-gray-700 mb-4">
            Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, 
            bis der Zweck für die Datenverarbeitung entfällt. Wenn Sie ein berechtigtes Löschersuchen geltend machen oder eine Einwilligung zur 
            Datenverarbeitung widerrufen, werden Ihre Daten gelöscht, sofern wir keine anderen rechtlich zulässigen Gründe für die Speicherung Ihrer 
            personenbezogenen Daten haben.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Widerruf Ihrer Einwilligung zur Datenverarbeitung</h3>
          <p className="text-gray-700 mb-4">
            Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit 
            widerrufen. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Auskunft, Löschung und Berichtigung</h3>
          <p className="text-gray-700 mb-4">
            Sie haben im Rahmen der geltenden gesetzlichen Bestimmungen jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten 
            personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung und ggf. ein Recht auf Berichtigung oder Löschung 
            dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit an uns wenden.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">4. Datenerfassung auf dieser Website</h2>
          
          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Cookies</h3>
          <p className="text-gray-700 mb-4">
            Unsere Internetseiten verwenden so genannte „Cookies". Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. 
            Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert. 
            Session-Cookies werden nach Ende Ihres Besuchs automatisch gelöscht. Permanente Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese 
            selbst löschen oder eine automatische Löschung durch Ihren Webbrowser erfolgt.
          </p>
          <p className="text-gray-700 mb-4">
            Cookies können von uns (First-Party-Cookies) oder von Drittunternehmen stammen (sog. Third-Party-Cookies). Third-Party-Cookies ermöglichen die 
            Einbindung bestimmter Dienstleistungen von Drittunternehmen innerhalb von Webseiten.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Kontaktformular</h3>
          <p className="text-gray-700 mb-4">
            Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen 
            Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre 
            Einwilligung weiter.
          </p>
          <p className="text-gray-700 mb-4">
            Die Verarbeitung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO, sofern Ihre Anfrage mit der Erfüllung eines Vertrags 
            zusammenhängt oder zur Durchführung vorvertraglicher Maßnahmen erforderlich ist. In allen übrigen Fällen beruht die Verarbeitung auf unserem 
            berechtigten Interesse an der effektiven Bearbeitung der an uns gerichteten Anfragen (Art. 6 Abs. 1 lit. f DSGVO) oder auf Ihrer Einwilligung 
            (Art. 6 Abs. 1 lit. a DSGVO) sofern diese abgefragt wurde.
          </p>

          <h3 className="text-xl font-bold text-gray-900 mt-6 mb-3">Anfrage per E-Mail oder Telefon</h3>
          <p className="text-gray-700 mb-4">
            Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) 
            zum Zwecke der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
          </p>

          <h2 className="text-2xl font-bold text-gray-900 mt-8 mb-4">5. Ihre Rechte</h2>
          <p className="text-gray-700 mb-4">
            Sie haben folgende Rechte:
          </p>
          <ul className="list-disc pl-6 text-gray-700 mb-4 space-y-2">
            <li>Recht auf Auskunft über Ihre bei uns gespeicherten Daten</li>
            <li>Recht auf Berichtigung unrichtiger Daten</li>
            <li>Recht auf Löschung Ihrer Daten</li>
            <li>Recht auf Einschränkung der Datenverarbeitung</li>
            <li>Recht auf Datenübertragbarkeit</li>
            <li>Recht auf Widerspruch gegen die Datenverarbeitung</li>
            <li>Recht auf Beschwerde bei einer Aufsichtsbehörde</li>
          </ul>

          <p className="text-gray-700 mb-4 mt-8">
            <strong>Stand:</strong> {new Date().toLocaleDateString('de-DE')}
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}
